import { AfterViewInit, ElementRef, EventEmitter, Input, OnDestroy, Output, ViewChild, Directive } from '@angular/core';
import { Subscription } from 'rxjs';
import { NgxMonacoEditorConfig } from './config';
import isRequired from '../../decorators/is-required';

let loadedMonaco = false;
let loadPromise: Promise<void>;
declare const require: any;

type EditorTypes = monaco.editor.IStandaloneCodeEditor | monaco.editor.IStandaloneDiffEditor;

@Directive()
export abstract class BaseEditor<EditorType extends EditorTypes> implements AfterViewInit, OnDestroy {
  @ViewChild('editorContainer') _editorContainer: ElementRef;
  // tslint:disable-next-line:no-output-on-prefix
  @Output() onInit = new EventEmitter<any>();
  _editor: EditorType;
  private _options: any;
  protected _windowResizeSubscription: Subscription;

  @isRequired
  @Input('options')
  set options(options: any) {
    this._options = Object.assign({}, this.config.defaultOptions, options);
    if (this._editor) {
      this._editor.dispose();
      this.initMonaco(options);
    }

    console.log(['[base-editor] options set']);
  }

  get options(): any {
    return this._options;
  }

  constructor(private config: NgxMonacoEditorConfig) {}

  ngAfterViewInit(): void {
    if (loadedMonaco) {
      // Wait until monaco editor is available
      loadPromise.then(() => {
        this.initMonaco(this.options);
      });
    } else {
      loadedMonaco = true;
      loadPromise = new Promise<void>((resolve: any) => {
        const baseUrl = this.config.baseUrl || '/assets';
        if (typeof((<any>window).monaco) === 'object') {
          resolve();
          return;
        }
        const onGotAmdLoader: any = () => {
          // Load monaco
          (<any>window).require.config({ paths: { 'vs': `${baseUrl}/monaco/vs` } });
          (<any>window).require(['vs/editor/editor.main'], () => {
            if (typeof this.config.onMonacoLoad === 'function') {
              this.config.onMonacoLoad();
            }
            this.initMonaco(this.options);
            resolve();
          });
        };

        // Load AMD loader if necessary
        if (!(<any>window).require) {
          const loaderScript: HTMLScriptElement = document.createElement('script');
          loaderScript.type = 'text/javascript';
          loaderScript.src = `${baseUrl}/monaco/vs/loader.js`;
          loaderScript.addEventListener('load', onGotAmdLoader);
          document.body.appendChild(loaderScript);
        } else {
          onGotAmdLoader();
        }
      });
    }
  }

  protected abstract initMonaco(options: any): void;

  ngOnDestroy() {
    if (this._windowResizeSubscription) {
      this._windowResizeSubscription.unsubscribe();
    }
    if (this._editor) {
      this._editor.dispose();
      this._editor = undefined;
    }
  }
}
